import request from '@/utils/request';
//分页查询直营市场会员数据
export function queryDirectMarketMemberPage(param) {
  return request('/activityBooking/queryConsumePage', {
    method: 'POST',
    data: param,
  });
}
// 核销
export function consumeCode(param) {
  return request('/activityBooking/consumeCode', {
    method: 'POST',
    data: param,
  });
}
// 撤销核销
export function cancelConsume(param) {
  return request('/activityBooking/cancelConsume', {
    method: 'POST',
    data: param,
  });
}
